<template>
  <BContainer  fluid>
    <BRow>
      <BCol align-v="center" class="vh-100">
        <router-view></router-view>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script>
import {BCol, BContainer, BRow} from "bootstrap-vue-next";

export default {
  name: "Static",
  components: {BCol, BRow, BContainer}
}
</script>

<style scoped>

</style>
